<div class="page-header">
  <div class="row" style="padding: 7px;">
    <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 logo">
       <div class="hmchlogo">
          <img  src="assets/images/logo.png" alt="" class=""/>
       </div>
    </div>
    <div
       class="col-xl-8 col-lg-8 col-md-8 col-sm-8"
       style="text-align: center"
       >
       <div>
          <h4 class="hmchsty">HI-TECH MEDICAL COLLEGE & HOSPITAL</h4>
          <p class="Certified">
             (ISO 9001 : 2015 Certified)
          </p>
          <h4 class="address">
             HEALTH PARK , PANDARA , RASULGARH , BHUBANESWAR - 751025
          </h4>
          <p class="address">
             PHONE : (0674) 2371406/407/408, FAX : (0674)2371409
          </p>
          <h4 class="hmchsty">OPD PRESCRIPTION</h4>
       </div>
    </div>
    <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2">
       <div class="vbctlogo" >
          <img src="assets/images/vbct_logo.png" alt="" class=""/>
       </div>
    </div>
 </div>
</div>
